import React from 'react';
import CompanyNotes from '../../common/Notes/';

const Notes = (props) => {
  return <CompanyNotes companyId={props.match.params.companyId} />;
};

export default Notes;
